import React from 'react'
import { useTranslation } from 'react-i18next'
import { IssueEntity } from 'types/IssueEntity'
import { FactsTableRow } from '../../components/FactsTable'
import { formatBigMoney, formatNumber } from '../../../packages/utils/numberFormatters'
import * as sharesOrUnits from '../../../utils/issues/sharesOrUnits.js'
import Stack from '@mui/material/Stack'

export function OverAllotmentSizeSecondaryRow({ issue }: { issue: IssueEntity }) {
    const { t, i18n } = useTranslation()
    const locale = i18n.language

    if (!issue.overAllotmentSizeSecondary) return null

    const isIpoWithIntervalSubPrice =
        issue.type === 'IPO' && !issue.unitSubPrice && issue.ipoIntervalHigh !== null && issue.ipoIntervalLow !== null

    const subPrice =
        issue.unitSubPrice !== null
            ? parseFloat(issue.unitSubPrice)
            : isIpoWithIntervalSubPrice
              ? (parseFloat(issue.ipoIntervalHigh) + parseFloat(issue.ipoIntervalLow)) / 2
              : null

    return (
        <FactsTableRow label={t('pages.issues.terms.overAllotmentSecondary')}>
            <Stack>
                {`${formatNumber(issue.overAllotmentSizeSecondary, { locale, decimals: 0 })} ${
                    sharesOrUnits.isUnit(issue) ? t('pages.issues.terms.units') : t('pages.issues.terms.sharesWord')
                }`}
                {subPrice !== null
                    ? formatBigMoney(issue.overAllotmentSizeSecondary * parseFloat(subPrice), {
                          locale,
                          currencySymbol: issue.currency,
                          decimals: 0,
                          tooltip: true,
                      })
                    : null}
            </Stack>
        </FactsTableRow>
    )
}
